import React from 'react';
import { connect } from "react-redux";
import { createTheme, ThemeProvider } from '@mui/material';
import { Portlet, PortletBody, PortletHeader } from "../../../partials/content/Portlet";
import ReactToPrint from "react-to-print";
import { Button } from "react-bootstrap";
import PortletSpinner from '../../../partials/layout/PortletSpinner';
import TableActionItems from './widgets/TableActionItems';
import moment from 'moment';
import NotifyArea2 from './widgets/NotifyArea2'
import { FormattedMessage, injectIntl } from "react-intl";
import Common from '../../../shared/common';



const theme = createTheme({
    typography: { fontSize: 20 },
});

class ContractRagReport extends React.Component {
    constructor(props) {
        super(props);
        this.printDivRef = React.createRef();
    }


    printHandler = () => {
        this.printerRef.handlePrint();
    }
    renderToolbar = () => {
        return (
            <div style={{ display: 'flex', flexFlow: 'row-reverse', margin: "20px 0px" }}>
                <Button onClick={this.printHandler} variant="primary" size="sm">
                    <i className="fas fa-print"></i>
                    <FormattedMessage id="CONTRACT.DASHBOARD.PRINT_REPORT" />
                </Button>
            </div>
        );
    }
    render() {
        const {  contractDashboard, contract, contractTemplate, actions } = this.props;
        if (!contractDashboard || !contractTemplate) {
            return (<PortletSpinner />);
        }

        const { resources } = contractTemplate;


        return (
            <Portlet ref={this.printDivRef}>
                <PortletHeader
                    title={`${this.props.intl.formatMessage({ id: 'CONTRACT.RAG.TITLE' })} - ${contract.name} - ${moment().format('L')}`}
                    toolbar={this.renderToolbar()} />
                <ReactToPrint
                    ref={el => (this.printerRef = el)}
                    trigger={() => (<div style={{ display: 'none' }} ></div>)}
                    content={() => this.printDivRef.current}
                />
                <PortletBody style={{ maxWidth: 1200 }}>
                    <ThemeProvider theme={theme}>
                        <TableActionItems />


                        <>
                            <NotifyArea2
                                key={"PA_SUPPLIER"}
                                skey={"PA_SUPPLIER"}
                                title={this.props.intl.formatMessage({ id: 'CONTRACT.HEALTH.OUTSTANDING_PARTY' }, { PARTY: resources.SUPPLIER_NAME })}
                                actionsObj={actions.SUPPLIER}
                                contractid={contract.contractid}
                                contract={contract}
                                contractTemplate={contractTemplate}

                            />
                            <NotifyArea2
                                key={"PA_PM"}
                                skey={"PA_PM"}
                                title={this.props.intl.formatMessage({ id: 'CONTRACT.HEALTH.OUTSTANDING_PARTY' }, { PARTY: resources.PM_NAME })}
                                actionsObj={actions.PM}
                                contractDashboard={contractDashboard}
                                contractid={contract.contractid}
                                contract={contract}
                                contractTemplate={contractTemplate}
                            />
                            {
                                contractTemplate.parties.supervisorExist && (
                                    <NotifyArea2
                                        key={"PA_SUPERVISOR"}
                                        skey={"PA_SUPERVISOR"}
                                        title={this.props.intl.formatMessage({ id: 'CONTRACT.HEALTH.OUTSTANDING_PARTY' }, { PARTY: resources.SUPERVISOR_NAME })}
                                        actionsObj={actions.SUPERVISOR}
                                        contractDashboard={contractDashboard}
                                        contractid={contract.contractid}
                                        contract={contract}
                                        contractTemplate={contractTemplate}
                                    />
                                )
                            }
                            {
                                contractTemplate.parties.clientExist && (
                                    <NotifyArea2
                                        key={"PA_CLIENT"}
                                        skey={"PA_CLIENT"}
                                        title={this.props.intl.formatMessage({ id: 'CONTRACT.HEALTH.OUTSTANDING_PARTY' }, { PARTY: resources.CLIENT_NAME })}
                                        actionsObj={actions.CLIENT}
                                        contractDashboard={contractDashboard}
                                        contractid={contract.contractid}
                                        contract={contract}
                                        contractTemplate={contractTemplate}
                                    />
                                )
                            }
                        </>

                    </ThemeProvider>
                </PortletBody>
            </Portlet>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractDashboard: store.contract.dashboard,
    contractTemplate: store.contract.template,
    actions: store.contract.manualActions,
});

export default injectIntl(connect(mapStateToProps)(ContractRagReport));